<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="formData.tanggal_awal"
          type="date"
          label="Dari Tanggal"
          outlined
          clearable
          dense
          autofocus
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field
          v-model="formData.tanggal_akhir"
          type="date"
          label="Sampai Tanggal"
          outlined
          clearable
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-btn color="primary" @click="fetchLaporan">
          Cari
        </v-btn>
      </v-col>
    </v-row>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <p v-if="state.noData">No Data</p>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <div class="left">
          <h2 class="report-title">LAPORAN NOTA BELUM LUNAS PER COLLECTOR</h2>
        </div>
      </div>

      <div class="mt-4">
        <div v-for="el in data" :key="el.id" class="mb-4">
          <h2>Kolektor: {{ el.info.nama }}</h2>
          <h3>Total: {{ totalInvoice(el.items) }}</h3>
          <table width="100%">
            <thead>
              <th class="text-left">Tgl Nota</th>
              <th class="text-left">No Nota</th>
              <th class="text-left">Nama Customer</th>
              <th>Kubikasi</th>
              <th>Tonase</th>
              <th class="text-right">Biaya Tambahan</th>
              <th class="text-right">Total Invoice</th>
            </thead>
            <tbody>
              <tr v-for="item in el.items" :key="item.id">
                <td>{{ formatDate(item.tgl_nota) }}</td>
                <td>{{ item.nomor_nota }}</td>
                <td>{{ item.nama_customer }}</td>
                <td class="text-center">
                  {{ totalKubikasi(item.invoice_detil) }}
                </td>
                <td class="text-center">
                  {{ totalTonase(item.invoice_detil) }}
                </td>
                <td class="text-right">
                  {{ formatCurrency(item.biaya_lain_total) }}
                </td>
                <td class="text-right">
                  {{
                    formatCurrency(
                      Math.abs(item.i_total) +
                        Math.abs(item.ii_total) +
                        Math.abs(item.biaya_lain_total)
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: true
      },
      formData: {
        tanggal_awal: "",
        tanggal_akhir: ""
      },
      data: [],
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchLaporan() {
      this.state.loading = true;

      const params = new URLSearchParams();
      if (this.formData.tanggal_awal && this.formData.tanggal_akhir) {
        params.append("tanggal_awal", this.formData.tanggal_awal);
        params.append("tanggal_akhir", this.formData.tanggal_akhir);
      }

      const query = params.toString();

      await axios
        .get(`invoice/laporan-nota-belum-lunas${query ? `?${query}` : ""}`)
        .then(res => {
          if (res.data.length === 0) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    totalInvoice(data) {
      let total = 0;

      data.forEach(el => {
        total +=
          Math.abs(el.i_total) +
          Math.abs(el.ii_total) +
          Math.abs(el.biaya_lain_total);
      });

      return this.formatCurrency(total);
    },
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      if (Number.isNaN(d.getTime())) return "-";
      return `${String(d.getDate()).padStart(2, "0")}-${String(
        d.getMonth() + 1
      ).padStart(2, "0")}-${d.getFullYear()}`;
    },
    totalKubikasi(data) {
      let total = 0;

      (data || []).forEach(invoice => {
        (invoice.ttb?.ttb_rinci || []).forEach(rinci => {
          total += rinci.m3;
        });
      });

      return total.toFixed(2);
    },
    totalTonase(data) {
      let total = 0;

      (data || []).forEach(invoice => {
        (invoice.ttb?.ttb_rinci || []).forEach(rinci => {
          total += rinci.ton;
        });
      });

      return total.toFixed(2);
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    }
  },
  created() {
    this.fetchLaporan();
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}
</style>
